import { isUtmTag } from 'core/user/entities';

export const sanitizeEventSourceUrl = (value: string): string | null => {
  try {
    const url = new URL(value);

    if (url.protocol !== 'https:' || !!url.username || !!url.password) {
      return null;
    }

    const marketingParams = new URLSearchParams();

    url.searchParams.forEach((paramValue, paramName) => {
      if (isUtmTag(paramName)) {
        marketingParams.append(paramName, paramValue);
      }
    });

    url.hash = '';
    url.search = marketingParams.toString();

    return url.toString();
  } catch {
    return null;
  }
};
